import { render } from "./Subscriptions.vue?vue&type=template&id=23f28f06&scoped=true&ts=true"
import script from "./Subscriptions.vue?vue&type=script&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&lang=ts"

import "./Subscriptions.vue?vue&type=style&index=0&id=23f28f06&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f28f06"]])

export default __exports__